import React from "react";
import Slider from "../../components/Slider/Slider";
import Categories from "../../components/Categories/Categories";

function Home() {

  return (
    <>
      <Slider />
      <Categories />
    </>
  );
}

export { Home};